import React, { useState } from "react";
import {
  headerBodyWrapper, headerLink, headerImage,
  headerDescription, headerTextIcon, headerText,
  link, textLinks, linkGroupWrapper, linkGroup,
  headerImageWrapper, combinedLinks, optImageWrapper,
  optImage, optDesc, optText, optIcon,
  categoryLinksWrapper, categoryLinksContainer,
  singleCategory, singleCategoryLinks, categoryTitleContainer,
  iconBox, linkContainer, notActiveCategory, activeCat, categoryName
} from "./body.mod.scss";
import Image from "components/image";
import Link from "components/link";
import getImagePath from "helpers/get-image-path";
import { trackMenuClick } from "helpers/analytics";

// Image Links Component
const ImageLinks = ({ data }) => {

  return (
    <div className={headerImageWrapper}>
      {
        data?.links?.map((linkData) => (
          <Link className={headerLink} key={linkData._key} to={linkData.url}>
            <Image
              className={headerImage}
              image={linkData.linkImage}
              alt={linkData?.linkImage?.alt?.replace("Olav ", "Olavson ")}
            />
            <div className={headerDescription}>
              <span className={headerText}>{linkData.title}</span>
              <span className={headerTextIcon} />
            </div>
          </Link>
        ))
      }
    </div>
  );
};

// Combined Image + Links Component
const CombinedLinks = ({ data }) => {
  const Links = data?.links?.map((lnkGroup) => {
    const groupLinks = lnkGroup?.links?.map((lnk) => (<Link key={lnk?._key} className={link} to={lnk?.url} onClick={() => trackMenuClick(lnk)}>{lnk?.title}</Link>));
    return (
      <div key={lnkGroup?._key} className={linkGroupWrapper}>
        <span className={linkGroup}>{lnkGroup?.title}</span>
        {groupLinks}
      </div>
    );
  });

  const [activeCategory, setActiveCategory] = useState(0);

  const handleCategoryHover = (categoryIndex) => {
    setActiveCategory(categoryIndex);
  };

  const handleMenuClose = () => {
    setActiveCategory(0);
  };

  const CategoryTitle = data?.categoryLinks?.map((link, index) => {

    return (
      <div
        className={categoryLinksContainer}
        key={link?._key}
        onMouseEnter={() => handleCategoryHover(index)}
      >
        <p className={activeCategory === index ? activeCat : notActiveCategory}>
          <Link to={link?.url} onClick={() => trackMenuClick(link)}>
            {link?.title}
          </Link>
        </p>
      </div>
    );
  });

  const CategoryLinks = data?.categoryLinks?.map((linkGroup, index) => {
    const groupLinks = linkGroup?.links?.map((lnk) => (
      <Link to={lnk?.url} key={lnk?._key} className={singleCategory} onClick={() => trackMenuClick(linkGroup)}>
        <p className={categoryName}>{lnk?.title}</p>
        <div className={singleCategoryLinks}>
          {lnk?.links?.map((link) => (
            <Link key={link?._key} className={linkContainer} to={link?.url} onClick={() => trackMenuClick(link)}>
              <div className={iconBox}>
                {link?.icon && <img src={getImagePath(link?.icon)} alt={link?.icon?.alt} />}
              </div>
              {link?.title}
            </Link>
          ))}
        </div>
      </Link>
    ));

    return (
      activeCategory === index && (
        <div className={categoryLinksContainer} key={linkGroup?._key}>
          {groupLinks}
        </div>
      )
    );
  });




  const OptionalImage = () => (
    <Link className={optImageWrapper} to={data.optionalImageUrl} onClick={() => trackMenuClick({
      url: data.optionalImageUrl, title: data.optionalTitle
    })}>
      <Image
        className={optImage}
        image={data.optionalLinkImage}
        alt={data?.optionalLinkImage?.alt}
      />
      <div className={optDesc}>
        <span className={optText}>{data.optionalTitle}</span>
        <span className={optIcon} />
      </div>
    </Link>
  );

  return (
    <div className={combinedLinks}>
      <div className={textLinks}>
        {CategoryLinks ?
          <div className={categoryLinksWrapper} onMouseLeave={() => handleMenuClose()}>
            <div className={categoryTitleContainer}>{CategoryTitle}</div>
            {CategoryLinks}
          </div> :
          Links}
      </div>
      {data?.optionalLinkImage &&
        <OptionalImage />}
    </div>
  );
};

// Only Text Links Component
const TextLinks = ({ data }) => {
  const Links = data?.links?.map((lnkGroup) => {
    const groupLinks = lnkGroup?.links?.map((lnk) => (<Link key={lnk?._key} className={link} to={lnk?.url} onClick={() => trackMenuClick(lnk)}>{lnk?.title}</Link>));
    return (
      <div key={lnkGroup?._key} className={linkGroupWrapper}>
        <span className={linkGroup}>{lnkGroup?.title}</span>
        {groupLinks}
      </div>
    );
  });

  return (
    <div className={textLinks}>
      {Links}
    </div>
  );
};

const HeaderBody = ({ data }) => {
  if (!data || !data._type) return <></>;

  const linkTemplateType = () => {
    if (data._type === "imageLink") return <ImageLinks data={data} />;
    else if (data._type === "combinedLink") return <CombinedLinks data={data} />;
    else if (data._type === "textLink") return <TextLinks data={data} />;
  };

  return (
    <div className={headerBodyWrapper}>
      {linkTemplateType()}
    </div>
  );
};

export default HeaderBody;
